var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88889 18H19.1111C19.6 18 20 17.55 20 17C20 16.45 19.6 16 19.1111 16H4.88889C4.4 16 4 16.45 4 17C4 17.55 4.4 18 4.88889 18ZM4.88889 13H19.1111C19.6 13 20 12.55 20 12C20 11.45 19.6 11 19.1111 11H4.88889C4.4 11 4 11.45 4 12C4 12.55 4.4 13 4.88889 13ZM4 7C4 7.55 4.4 8 4.88889 8H19.1111C19.6 8 20 7.55 20 7C20 6.45 19.6 6 19.1111 6H4.88889C4.4 6 4 6.45 4 7Z",
    fill: "#080808"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.573e5ad5a0ee56b24f411c7573176b0c.svg";
export { ForwardRef as ReactComponent };